module.exports = __webpack_public_path__ + "img/simon-smc.7586aeb3.jpg";